// @ts-nocheck

"use client"

import Logo from "@/components/BeLuxe/Logo"
import {
    Drawer,
    Button,
    Typography,
    IconButton,
} from "@material-tailwind/react"
import Link from "next/link"
import Image from "next/image"
import React from "react"
import "./styles.scss"

const Item = ({ label, link }) => {
    return (
        <Link href={link || "/"} className="text-[14px] font-bold text-white uppercase border-b-2 border-b-transparent hover:border-b-[#E7D1A4] font-['Comfortaa'] leading-[18px] tracking-[0.1rem] pb-2 -mb-2 w-fit duration-300 ease-in-out">
            {label || ""}
        </Link>
    )
}

const ItemMobile = ({ label, link }) => {
    return (
        <Link href={link || "/"} className="text-[14px] font-bold leading-[32px] text-[#212123] text-left tracking-[0.05rem] uppercase w-full">
            {label || ""}
        </Link>
    )
}

const Menu = () => {
    const [open, setOpen] = React.useState(false)
    const openDrawer = () => setOpen(true)
    const closeDrawer = () => setOpen(false)
    return (
        <nav className="bg-[#2A3026] w-full h-[44px] lg:h-[100px] flex flex-row gap-5 justify-between lg:justify-between items-center px-[1rem] lg:px-[50px] menuBeLuxe-desktop__wrapper z-[100] relative ">
            <div className="flex lg:hidden flex flex-row justify-start w-1/3">
                <button type="button" onClick={openDrawer} className="relative w-[28px] h-[14px]">
                    <Image
                        src="/images/beluxe/hamburger-menu.svg"
                        alt="Menu"
                        lang="en"
                        layout="fill"
                        objectFit="contain"
                        loading="eager"
                        quality={100}
                    />
                </button>
            </div>
            <div className="hidden lg:flex flex-row gap-8 justify-start items-center w-1/3">
                {[{
                    label: "Home",
                    link: "/"
                }, {
                    label: "Properties",
                    link: "/properties"
                }, {
                    label: "New developments",
                    link: "/new-developments"
                }].map((item, index) =>
                    <Item
                        label={item.label}
                        link={item.link}
                        key={index}
                    />
                )}
            </div>
            <div className="flex lg:hidden flex flex-row justify-center w-1/3">
                <Logo image="/images/beluxe/logo_beluxe--mobile.svg" />
            </div>
            <div className="hidden lg:flex flex-row gap-8 justify-center items-center w-1/3">
                <Logo />
            </div>
            <div className="flex lg:hidden flex flex-row justify-end w-1/3">
                <select className="bg-[#2A3026] border border-[#2A3026] font-['Comfortaa'] text-white text-sm rounded-lg focus:ring-[#2A3026] focus:border-[#2A3026] block w-fit p-2.5 appearance-none">
                    <option>EN</option>
                    {/* <option>ES</option> */}
                </select>
            </div>
            <div className="hidden lg:flex flex-row gap-8 justify-end items-center w-1/3">
                {[{
                    label: "Guides",
                    link: "/guides"
                }, {
                    label: "About",
                    link: "/about"
                }, {
                    label: "Contact",
                    link: "/contact"
                }].map((item, index) =>
                    <Item
                        label={item.label}
                        link={item.link}
                        key={index}
                    />
                )}
                <select className="bg-[#2A3026] border border-[#2A3026] font-['Comfortaa'] text-white text-sm rounded-lg focus:ring-[#2A3026] focus:border-[#2A3026] block w-fit p-2.5 appearance-none">
                    <option>EN</option>
                    {/* <option>ES</option> */}
                </select>
            </div>
            <Drawer
                open={open}
                onClose={closeDrawer}
                overlay
                className="px-5 py-12 z-[1000] !max-h-screen h-screen bg-[#FBFAF7] flex flex-col gap-1 justify-start items-center"
            >
                {[{
                    label: "Home",
                    link: "/"
                }, {
                    label: "Properties",
                    link: "/properties"
                }, {
                    label: "New developments",
                    link: "/new-developments"
                }, {
                    label: "Guides",
                    link: "/guides"
                }, {
                    label: "About",
                    link: "/about"
                }, {
                    label: "Contact",
                    link: "/contact"
                }].map((item, index) =>
                    <ItemMobile
                        label={item.label}
                        link={item.link}
                        key={index}
                    />
                )}
            </Drawer>
        </nav>
    )
}

export default Menu